import { useCallback } from "react";

import { MagnifyingGlassIcon, XIcon } from "@phosphor-icons/react";

import FlexWrapper, { FlexDirection } from "@gx/dls/containers/FlexWrapper";
import HorizontalDivider from "@gx/dls/dividers/HorizontalDivider";
import TextInput from "@gx/dls/inputs/TextInput";

import BaseHeader from "@/layouts/components/BaseHeader";
import BaseToolbar from "@/layouts/components/BaseToolbar";

interface CreateSourceSelectorHeaderProps {
  search: string;
  onSearchChange: (search: string) => void;
  onClose: () => void;
}

const CreateSourceSelectorHeader = ({
  search,
  onSearchChange,
  onClose,
}: CreateSourceSelectorHeaderProps) => {
  const handleSearchClear = useCallback(() => {
    onSearchChange("");
  }, [onSearchChange]);

  return (
    <FlexWrapper direction={FlexDirection.COLUMN} fillWidth>
      <FlexWrapper padding="16px" fillWidth>
        <BaseHeader
          title="New data source"
          description="Galaxy will automatically index your data."
          onClose={onClose}
        />
      </FlexWrapper>
      <HorizontalDivider />
      <FlexWrapper padding="8px 16px" fillWidth>
        <BaseToolbar
          leadingActions={[
            <TextInput
              key="search"
              placeholder="Search sources..."
              leading={{ icon: MagnifyingGlassIcon }}
              trailing={search ? { icon: XIcon, onClick: handleSearchClear } : undefined}
              onChange={onSearchChange}
              value={search}
              fillWidth
            />,
          ]}
        />
      </FlexWrapper>
    </FlexWrapper>
  );
};

export default CreateSourceSelectorHeader;
